const normalizeConversationContextValue = value => {
  if (Array.isArray(value)) {
    return [...value].sort();
  }

  return value ?? null;
};

export const buildConversationContextKey = (filters = {}) => {
  const normalizedContext = {
    assigneeType: normalizeConversationContextValue(filters.assigneeType),
    conversationType: normalizeConversationContextValue(filters.conversationType),
    inboxId: normalizeConversationContextValue(filters.inboxId),
    labels: normalizeConversationContextValue(filters.labels),
    sortBy: normalizeConversationContextValue(filters.sortBy),
    status: normalizeConversationContextValue(filters.status),
    teamId: normalizeConversationContextValue(filters.teamId),
    updatedWithin: normalizeConversationContextValue(filters.updatedWithin),
  };

  return JSON.stringify(normalizedContext);
};

export const hasConversationContextFilters = (filters = {}) => {
  const contextFilterKeys = [
    'assigneeType',
    'conversationType',
    'inboxId',
    'labels',
    'sortBy',
    'status',
    'teamId',
    'updatedWithin',
  ];

  return contextFilterKeys.some(key => filters[key] !== undefined);
};

export const defaultConversationStats = () => ({
  mineCount: 0,
  unAssignedCount: 0,
  allCount: 0,
  groupCount: 0,
});
